import { get } from 'lodash-es';
import type { FormikHelpers } from 'formik';

type FormikLike = {
  submitCount: number;
  errors: Record<string, unknown>;
  values: Record<string, unknown>;
  handleChange: (e: React.ChangeEvent) => void;
  handleBlur: (e: React.FocusEvent) => void;
  setFieldValue: (field: string, value: unknown) => void;
  setFieldTouched: (field: string, isTouched?: boolean) => void;
};

type MutationError = {
  networkError?: { message: string; result?: unknown };
  graphQLErrors?: { message: string }[];
};

export const getError = (form: FormikLike, attribute: string) => {
  if (form.submitCount > 0 && get(form.errors, attribute)) {
    return get(form.errors, attribute);
  }
  return null;
};

export const fieldProps = (props: FormikLike, attribute: string) => {
  const { handleChange, handleBlur, values } = props;
  const value = get(values, attribute);
  const error = getError(props, attribute);
  return {
    handleChange,
    handleBlur,
    value,
    error
  };
};

export const formikFieldProps = (formProps: FormikLike) => {
  return {
    onChange: formProps.setFieldValue,
    onBlur: formProps.setFieldTouched
  };
};

export const setFieldProps = (props: FormikLike, attribute: string) => {
  const { values } = props;
  const value = get(values, attribute);
  const error = getError(props, attribute);
  return Object.assign(formikFieldProps(props), {
    value,
    error
  });
};

export const processMutationError = (error: unknown, actions: FormikHelpers<unknown>) => {
  const mutationError = error as MutationError;
  if (mutationError?.networkError) {
    console.error(
      'networkError',
      mutationError.networkError.message,
      mutationError.networkError.result
    );
    actions.setStatus({
      networkError: mutationError.networkError
    });
  } else if (mutationError?.graphQLErrors?.length) {
    console.error('graphQLErrors', mutationError.graphQLErrors);
    actions.setStatus({
      graphQLErrors: mutationError.graphQLErrors
    });
  } else {
    console.error('Unexpected mutation error', error);
    actions.setStatus({
      networkError: { message: 'An unexpected error occurred' }
    });
  }
  actions.setSubmitting(false);
};
